import OrganizationChange from './organization-change.connect'

export default OrganizationChange
